import axios from "axios"

import { logout, normalizeStoragePayload } from "utils"
import router from "routes/index.routes"
import { refreshAccessToken } from "./accountService"

const API_AUTH_URL =
  process.env.REACT_APP_API_AUTH_URL || "https://api.farasod.ir/auth"

const API_SUBSCRIBE_URL =
  process.env.REACT_APP_API_SUBSCRIBE_URL ||
  "https://api.farasod.ir/subscribe"

const API_MAIN_URL =
  process.env.REACT_APP_API_MAIN_URL || "https://api.farasod.ir/main"

const API_ANALYTIC_URL =
  process.env.REACT_APP_API_ANALYTIC_URL || "https://api.farasod.ir/analytic"

const API_STORAGE_URL =
  process.env.REACT_APP_API_STORAGE_URL || "https://api.farasod.ir/storage"

let isRefreshing = false
let failedQueue = []

const handleRequest = req => {
  try {
    if (localStorage.at) {
      req.headers.common["X-Access-Token"] =
        `Bearer ${localStorage.at}`
    }

    req.headers.common["X-Service-Client-Name"] = "subscribe"
  } catch (err) {
    console.log(err)
  }

  return req
}

const processQueue = (error, token = null) => {
  failedQueue.forEach(prom => {
    error
      ? prom.reject(error)
      : prom.resolve(token)
  })
  failedQueue = []
}

const waitingForToken = () => (
  new Promise((resolve, reject) => {
    failedQueue.push({ resolve, reject })
  })
)

const handleError = async (error, api) => {
  if (!error.response) return Promise.reject(error)

  const { status, config: originalRequest } = error.response

  if (status === 401 && !originalRequest._retry) {
    if (isRefreshing) {
      try {
        const accessToken = await waitingForToken()

        originalRequest.headers["X-Access-Token"] = `Bearer ${accessToken}`

        return api(originalRequest)
      } catch (err) {
        return Promise.reject(err)
      }
    }

    originalRequest._retry = true

    isRefreshing = true

    try {
      const { accessToken, refreshToken } =
        await refreshAccessToken()

      localStorage.setItem("at", accessToken)

      localStorage.setItem("rt", refreshToken)

      originalRequest.headers["X-Access-Token"] = `Bearer ${accessToken}`

      processQueue(null, accessToken)

      return api(originalRequest)
    } catch (err) {
      if (err?.response?.status === 404) {
        processQueue(err, null)

        logout()

        router.navigate("/")
      }

      return Promise.reject(error)
    } finally {
      isRefreshing = false
    }
  }

  return Promise.reject(error)
}

const normalizeResponse = response => ({
  ...response,
  data: normalizeStoragePayload(response.data)
})

const dhFoodsAuth = axios.create({
  baseURL: API_AUTH_URL
})
dhFoodsAuth.interceptors.request.use(handleRequest)
dhFoodsAuth.interceptors.response.use(
  normalizeResponse,
  error => handleError(error, dhFoodsAuth)
)

const dhFoodsAnalytic = axios.create({
  baseURL: API_ANALYTIC_URL
})
dhFoodsAnalytic.interceptors.request.use(handleRequest)
dhFoodsAnalytic.interceptors.response.use(
  normalizeResponse,
  error => handleError(error, dhFoodsAnalytic)
)

const dhFoods = axios.create({
  baseURL: API_SUBSCRIBE_URL
})
dhFoods.interceptors.request.use(handleRequest)
dhFoods.interceptors.response.use(
  normalizeResponse,
  error => handleError(error, dhFoods)
)

const dhFoodsStorage = axios.create({
  baseURL: API_STORAGE_URL
})
dhFoodsStorage.interceptors.request.use(handleRequest)
dhFoodsStorage.interceptors.response.use(
  response => response,
  error => handleError(error, dhFoodsStorage)
)

const dhFoodsMain = axios.create({
  baseURL: API_MAIN_URL
})
dhFoodsMain.interceptors.request.use(handleRequest)
dhFoodsMain.interceptors.response.use(
  normalizeResponse,
  error => handleError(error, dhFoodsMain)
)

export {
  dhFoods,
  dhFoodsMain,
  dhFoodsStorage,
  dhFoodsAuth,
  dhFoodsAnalytic
}
